export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref13985.9565fed5.jpg";